import { Button } from '@components/primitives/Button.js'
import { Input } from '@components/primitives/Input.js'
import { Select } from '@components/primitives/Select.js'
import { CATEGORIAS_DOCUMENTO } from '@utils/constants.js'
import type { ViewMode } from './types.js'

type Props = {
  search: string
  catFiltro: string
  viewMode: ViewMode
  importing: boolean
  onSearchChange: (value: string) => void
  onCatFiltroChange: (value: string) => void
  onViewModeChange: (mode: ViewMode) => void
  onNew: () => void
  onBatchImport: () => void
}

const catFilterOptions = [
  { value: '', label: 'Todas as categorias' },
  ...CATEGORIAS_DOCUMENTO.map((c) => ({ value: c, label: c })),
]

export function DocumentosToolbar({
  search,
  catFiltro,
  viewMode,
  importing,
  onSearchChange,
  onCatFiltroChange,
  onViewModeChange,
  onNew,
  onBatchImport,
}: Props) {
  return (
    <section className='cf3-block'>
      <div className='cf3-doc-toolbar'>
        <div className='cf3-doc-toolbar__search'>
          <Input
            name='doc-search'
            value={search}
            placeholder='Buscar por nome, fornecedor…'
            onChange={(e) => onSearchChange(e.target.value)}
            aria-label='Buscar documentos'
          />
        </div>

        <div className='cf3-doc-toolbar__controls'>
          <div className='cf3-doc-toolbar__cat'>
            <Select
              name='doc-cat-filter'
              value={catFiltro}
              options={catFilterOptions}
              onChange={(e) => onCatFiltroChange(e.target.value)}
              aria-label='Filtrar por categoria'
            />
          </div>

          <div className='cf3-doc-view-toggle' role='group' aria-label='Modo de visualização'>
            <button
              className={`cf3-doc-view-btn${viewMode === 'gallery' ? ' cf3-doc-view-btn--active' : ''}`}
              onClick={() => onViewModeChange('gallery')}
              aria-pressed={viewMode === 'gallery'}
              title='Galeria'
            >
              Galeria
            </button>
            <button
              className={`cf3-doc-view-btn${viewMode === 'list' ? ' cf3-doc-view-btn--active' : ''}`}
              onClick={() => onViewModeChange('list')}
              aria-pressed={viewMode === 'list'}
              title='Lista'
            >
              Lista
            </button>
          </div>
        </div>
      </div>

      <div className='cf3-doc-toolbar__actions cf3-doc-toolbar__actions--row'>
        <Button variant='primary' size='sm' onClick={onNew} aria-label='Adicionar documento'>
          + Documento
        </Button>
        <Button
          variant='secondary'
          size='sm'
          onClick={onBatchImport}
          loading={importing}
          aria-label='Importar vários arquivos'
        >
          Importar em lote
        </Button>
      </div>
    </section>
  )
}
